import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/item/deleteaction";
import updateaction from "../../context/action/item/updateaction";

const Edititemmodal = (props) => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  const [error4, seterror4] = useState(false);
  const [error5, seterror5] = useState(false);
  const [error6, seterror6] = useState(false);
  const [error7, seterror7] = useState(false);
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-11/12 sm:w-5/6 md:w-2/3 lg:w-2/3 max-w-7xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[90vh] overflow-y-auto">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      X
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-4 sm:p-6 flex-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                    <div className="w-full">
                      <label
                        className={
                          error
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="item_name"
                      >
                        ناوی کاڵا
                      </label>
                      <input
                        className={
                          error
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="item_name"
                        type="text"
                        placeholder="ناوی کاڵا"
                        onClick={(val)=>{val.target.select()}}
                        value={props.item_name}
                        onChange={(val) => props.setitem_name(val.target.value)}
                        onFocus={() => seterror(false)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        for="catee"
                        className={
                          error1
                          ?"block mb-2 text-xs font-bold text-red-500"
                          :"block mb-2 text-xs font-bold text-gray-700"
                        }
                      >
                        کاتیگۆری
                      </label>
                      <select
                        id="catee"
                        className={
                          error1
                          ?"bg-gray-50 border border-red-500 text-gray-900 rounded focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 mb-2 h-12"
                          :"bg-gray-50 border border-gray-300 text-gray-900 rounded focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 mb-2 h-12"
                        }
                        value={props.category_id}
                        onChange={(val) => {
                          props.setcategory_id(val.target.value);
                          var cat_id=(val.target.value);
                          
                          if(cat_id.trim()==""){
                            props.setitem_barcode("");
                          }else{
                            const filtered_category=initState?.category?.filter((res)=>res.category_id==cat_id)[0]
                            props.setitem_barcode(filtered_category?.category_start_code+"-"+(Number(filtered_category?.count_category)+1));
                          }
                        }}
                        onFocus={()=>seterror1(false)}
                      >
                        <option value="">کاتیگۆری</option>
                        {initState?.category.map((lis) => (
                          <option value={lis.category_id}>{lis.category_name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full">
                      <label
                        for="item_unit_many"
                        className={
                          error2
                          ?"block mb-2 text-sm font-medium text-red-500"
                          :"block mb-2 text-sm font-medium text-gray-900"
                        }
                      >
                        یەکەی کۆ
                      </label>
                      <select
                        id="item_unit_many"
                        className={
                          error2
                          ?"bg-gray-50 border border-red-500 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 mb-2 h-12"
                          :"bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 mb-2 h-12"
                        }
                        value={props.item_unit_many}
                        onChange={(val) => {
                          props.setitem_unit_many(val.target.value);
                        }}
                        onFocus={()=>seterror2(false)}
                      >
                        <option value="">یەکەی کۆ</option>
                        {initState?.unit.map((lis) => (
                          <option value={lis.unit_name}>{lis.unit_name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full">
                      <label
                        for="item_unit_one"
                        className={
                          error3
                          ?"block mb-2 text-sm font-medium text-red-900"
                          :"block mb-2 text-sm font-medium text-gray-900"
                        }
                      >
                        یەکەی تاک
                      </label>
                      <select
                        id="item_unit_one"
                        className={
                          error3
                          ?"bg-gray-50 border border-red-500 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 mb-2 h-12"
                          :"bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 mb-2 h-12"
                        }
                        value={props.item_unit_one}
                        onChange={(val) => {
                          props.setitem_unit_one(val.target.value);
                        }}
                        onFocus={()=>seterror3(false)}
                      >
                        <option value="">یەکەی تاک</option>
                        {initState?.unit.map((lis) => (
                          <option value={lis.unit_name}>{lis.unit_name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          error4
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="item_unit_one_of_many"
                      >
                        بڕی یەکەی تاک لە یەک یەکەی کۆدا
                      </label>
                      <input
                        className={
                          error4
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="item_unit_one_of_many"
                        type="number"
                        placeholder="بڕی یەکەی تاک لە یەک یەکەی کۆدا"
                        onClick={(val)=>{val.target.select()}}
                        value={props.item_unit_one_of_many}
                        onChange={(val) => props.setitem_unit_one_of_many(val.target.value)}
                        onFocus={() => seterror4(false)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          error5
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="grid-last-name"
                      >
                        کۆد
                      </label>
                      <input
                        className={
                          error5
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="grid-last-name"
                        type="text"
                        placeholder=""
                        disabled
                        onClick={(val)=>{val.target.select()}}
                        value={props.item_barcode}
                        onChange={(val) => props.setitem_barcode(val.target.value)}
                        onFocus={() => seterror5(false)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          error6
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2 mt-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-2"
                        }
                        for="grid-last-name"
                      >
                        نرخ
                      </label>
                      <input
                        className={
                          error6
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="grid-last-name"
                        type="number"
                        placeholder="نرخ"
                        onClick={(val)=>{val.target.select()}}
                        value={props.item_price}
                        onChange={(val) => props.setitem_price(val.target.value)}
                        onFocus={() => seterror6(false)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          error7
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2 mt-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-2"
                        }
                        for="grid-last-name"
                      >
                        ئاگادارکردنەوە لە کەمترین بڕ
                      </label>
                      <input
                        className={
                          error7
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="grid-last-name"
                        type="number"
                        placeholder="ئاگادارکردنەوە لە کەمترین بڕ"
                        onClick={(val)=>{val.target.select()}}
                        value={props.item_min_notification}
                        onChange={(val) =>
                          props.setitem_min_notification(val.target.value)
                        }
                        onFocus={() => seterror7(false)}
                      />
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                    type="button"
                    onClick={() => {
                      if (
                        window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") == true
                      ) {
                        deleteaction(props.item_id)(recaller)(setrecaller)(
                          initDispatch
                        )(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2"
                    type="button"
                    onClick={() => {
                      if (props.item_name == "" || !props.item_name) {
                        seterror(true);
                        return false;
                      }
                      if (props.category_id == "" || !props.category_id) {
                        seterror1(true);
                        return false;
                      }
                      if (props.item_unit_many == "" || !props.item_unit_many) {
                        seterror2(true);
                        return false;
                      }
                      if (
                        props.item_unit_one == "" ||
                        !props.item_unit_one
                      ) {
                        seterror3(true);
                        return false;
                      }
                      if (
                        props.item_unit_one_of_many < 0 ||
                        !props.item_unit_one_of_many
                      ) {
                        seterror4(true);
                        return false;
                      }
                      if (props.item_barcode == "" || !props.item_barcode) {
                        seterror5(true);
                        return false;
                      }
                      if (
                        props.item_price < 0 ||
                        !props.item_price
                      ) {
                        seterror6(true);
                        return false;
                      }
                      if (
                        props.item_min_notification < 0 ||
                        !props.item_min_notification
                      ) {
                        seterror7(true);
                        return false;
                      }
                      if (
                        window.confirm(
                          "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                        ) == true
                      ) {
                        updateaction(
                          props.item_name,
                          props.item_barcode,
                          props.item_price,
                          props.item_unit_one,
                          props.item_unit_many,
                          props.item_unit_one_of_many,
                          props.item_min_notification,
                          props.category_id,
                          props.item_id
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Edititemmodal;
